import React, { useState } from 'react'
import { tokens } from "../../../theme";
import {  MenuItem, SubMenu } from "react-pro-sidebar";
import { Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import Diversity3Icon from '@mui/icons-material/Diversity3';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AddCardIcon from '@mui/icons-material/AddCard';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import DescriptionIcon from "@mui/icons-material/Description";
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import AddchartIcon from '@mui/icons-material/Addchart';
import FactoryIcon from '@mui/icons-material/Factory';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SummarizeIcon from '@mui/icons-material/Summarize';
import WarningIcon from '@mui/icons-material/Warning';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import TvIcon from '@mui/icons-material/Tv';
import InventoryIcon from '@mui/icons-material/Inventory';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import CastConnectedIcon from '@mui/icons-material/CastConnected';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';
import InvertColorsIcon from '@mui/icons-material/InvertColors';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import AlignVerticalBottomIcon from '@mui/icons-material/AlignVerticalBottom';
import VerticalShadesClosedIcon from '@mui/icons-material/VerticalShadesClosed';
import EditIcon from '@mui/icons-material/Edit';
import MoneyIcon from '@mui/icons-material/Money';
import AllInboxIcon from '@mui/icons-material/AllInbox';
import FormatLineSpacingIcon from '@mui/icons-material/FormatLineSpacing';
import AppsIcon from '@mui/icons-material/Apps';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import HandymanIcon from '@mui/icons-material/Handyman';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import HomeRepairServiceOutlinedIcon from '@mui/icons-material/HomeRepairServiceOutlined';
import EngineeringIcon from '@mui/icons-material/Engineering';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Grid3x3Icon from '@mui/icons-material/Grid3x3';
import Grid4x4Icon from '@mui/icons-material/Grid4x4';
import { Inventory } from '@mui/icons-material';

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};


const Tejido = () => {
  const [selected, setSelected] = useState("Dashboard");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <>
                    <SubMenu
                      title="Tejido"
                      icon={<Grid4x4Icon/>}
                      style={{ color: colors.grey[300] }}
                    >
                      <SubMenu
                        title="Registros"
                        icon={<FactoryIcon />}
                        style={{ color: colors.grey[300] }}
                      >
                        <Item
                          title="Productos"
                          to="/registros/productostejidos"
                          icon={<Grid4x4Icon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Máquinas"
                          to="/registros/maquinastejido"
                          icon={<PrecisionManufacturingIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Stock"
                          to="/registros/stocktejido"
                          icon={<Inventory/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Orden de Producción"
                          to="/registros/ordenTejido"
                          icon={<AddCircleIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Producción"
                          to="/registros/produccion"
                          icon={<Grid3x3Icon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Registro Cliente"
                          to="/registro/cliente"
                          icon={<ReceiptOutlinedIcon />}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Registro Vehiculo"
                          to="/registro/vehiculo"
                          icon={<ReceiptOutlinedIcon />}
                          selected={selected}
                          setSelected={setSelected}
                        />
                      </SubMenu>
                      <SubMenu
                        title="Consultas"
                        icon={<ReceiptOutlinedIcon />}
                        style={{ color: colors.grey[300] }}
                      >
                        <Item
                          title="Rollos en espera"
                          to="/consultas/tejidoespera"
                          icon={<ReceiptOutlinedIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Rollos en stock"
                          to="/consultas/tejidoenstock"
                          icon={<ReceiptOutlinedIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Rollos Stock Evoluaço"
                          to="/consultas/stockEvoluaco"
                          icon={<ReceiptOutlinedIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Rollos General"
                          to="/consultas/rollosgeneral"
                          icon={<ReceiptOutlinedIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Producción"
                          to="/consultas/produccion"
                          icon={<ReceiptOutlinedIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Producción funcionarios"
                          to="/consultas/produccionfuncionarios"
                          icon={<EngineeringIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                      </SubMenu>
                        <SubMenu
                        title="Entrada"
                        icon={<MoveUpIcon />}
                        style={{ color: colors.grey[300] }}
                      ><Item
                          title="Rollos (en espera)"
                          to="/traslado/tejidoespera"
                          icon={<ReceiptOutlinedIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                      </SubMenu>
                      <SubMenu
                        title="Venta"
                        icon={<FactoryIcon />}
                        style={{ color: colors.grey[300] }}
                      ><Item
                          title="Pedido de venta"
                          to="/registros/pedidoventa"
                          icon={<ReceiptOutlinedIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Cargamento"
                          to="/view/CargamentoTejido"
                          icon={<LocalShippingIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Liberar"
                          to="/view/LiberarTejido"
                          icon={<LocalShippingIcon/>}
                          selected={selected}
                          setSelected={setSelected}
                        />
                        <Item
                          title="Historial de Ventas"
                          to="/view/historialVentasTejido"
                          icon={<ReceiptOutlinedIcon />}
                          selected={selected}
                          setSelected={setSelected}
                        />
                      </SubMenu>
                    </SubMenu>
              </>
  )
}

export default Tejido
